import { useContext, useCallback } from 'react'
import context from '../../contexts/learning-resources-filter'

const useLearningResourcesFilters = () => {
    const { filters, setFilters } = useContext(context)

    const {
        offset,
        limit,
        name,
        dimensions = [],
        types = []
    } = filters

    const updateFilters = useCallback((filterOverrides = {}) => {
        setFilters({ ...filters, ...filterOverrides})
    }, [filters, setFilters])

    //  Convenience methods
    const setName = useCallback(name => {
        updateFilters({ name })
    }, [updateFilters])

    const setOffset = useCallback(offset => {
        updateFilters({ offset })
    }, [updateFilters])

    return {
        //  Available filters
        limit,
        offset,
        name,
        dimensions,
        types,
        //  Setters
        setName,
        setOffset,
        //  General stuff
        filters,
        setFilters,
        updateFilters
    }
}

export default useLearningResourcesFilters
